import { IconBase, IconComponent } from './BaseIcon';

export const Close: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M32 2.818 29.192-.01 15.99 13.192 2.808-.01 0 2.818 13.182 16 0 29.202l2.808 2.808L15.99 18.828 29.192 32.01 32 29.202 18.818 16 32 2.818Z" />
  </IconBase>
);
